var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var PinterestSvg = /* @__PURE__ */ __name(function PinterestSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M9.249 18.133c-2.511-0.342-3.667-1.378-4.196-3.382-1.724-6.484 3.196-12.84 10.298-13.178 0.208-0.010 0.453-0.015 0.698-0.015 1.349 0 2.659 0.168 3.909 0.483l-0.11-0.023c5.996 1.467 8.729 6.871 6.867 13.342-1.231 4.28-3.924 7.004-7.556 7.084-1.689 0.036-3.4-0.711-5.267-1.142-0.889 2.929-1.2 6.547-4.307 9.142-0.126-0.879-0.198-1.895-0.198-2.927 0-2.123 0.304-4.176 0.872-6.116l-0.039 0.154c0.316-1.249 0.6-2.511 0.933-3.756 0.217-0.775 0.341-1.666 0.341-2.585 0-0.591-0.051-1.17-0.15-1.732l0.009 0.060c-0.213-1.369 0.298-2.973 0.889-4.302 0.538-1.218 1.809-1.658 3.164-1.111s1.573 1.693 1.284 2.942c-0.4 1.747-1.044 3.449-1.311 5.213-0.133 0.889 0.044 2.271 0.618 2.667 0.579 0.374 1.286 0.597 2.046 0.597 0.38 0 0.746-0.056 1.093-0.159l-0.027 0.007c1.125-0.505 2.037-1.317 2.652-2.329l0.015-0.026c0.961-1.551 1.53-3.433 1.53-5.447 0-0.714-0.072-1.412-0.208-2.086l0.011 0.067c-0.658-3.689-3.556-5.742-7.507-5.396-4.111 0.364-7.604 3.916-7.604 7.884 0 1.018 0.498 2.027 0.72 3.049 0.204 0.947 0.338 1.911 0.533 3.018z"
  }));
}, "PinterestSvg");
var PinterestIcon = /* @__PURE__ */ __name(function PinterestIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: PinterestSvg
  }, props));
}, "PinterestIcon");
export {
  PinterestIcon
};
